import {css} from "styled-components"

import {ButtonCssProps} from "./index"

const tertiaryCss = css<ButtonCssProps>`
  ${({theme, inverted}) => css`
    /* stylelint-disable no-duplicate-selectors */
    color: ${theme.colors.tertiary.r_400};
    border: none;
    background-color: transparent;
    border-radius: 0;
    padding: 0 0 ${theme.spacing.half} 0;

    path {
      fill: ${theme.colors.tertiary.r_400};
    }

    &:hover,
    &:focus,
    &:active {
      text-decoration: none;
      background-color: transparent;
      color: ${theme.colors.tertiary.r_400};
      box-shadow: 0px 2px 0px ${theme.colors.tertiary.r_400};
      path {
        fill: ${theme.colors.tertiary.r_400};
      }
    }

    &:disabled,
    &.disabled {
      color: ${theme.colors.primary2_100};
      border: none;
      path {
        fill: ${theme.colors.primary2_100};
      }
      &:hover,
      &:focus,
      &:active {
        box-shadow: none;
        path {
          fill: ${theme.colors.primary2_100};
        }
      }
    }
    ${inverted &&
    css`
      color: ${theme.colors.tertiary.red};
      path {
        fill: ${theme.colors.tertiary.red};
      }
      &:hover,
      &:active,
      &:focus {
        color: ${theme.colors.tertiary.red};
        box-shadow: 0px 2px 0px ${theme.colors.tertiary.red};
        background-color: transparent;
        path {
          fill: ${theme.colors.tertiary.red};
        }
      }
      &:disabled,
      &.disabled {
        color: ${theme.colors.primary2_200};
        border: none;
        box-shadow: none;
        path {
          fill: ${theme.colors.primary2_200};
        }
        &:hover,
        &:focus,
        &:active {
          box-shadow: none;
          path {
            fill: ${theme.colors.primary2_200};
          }
        }
      }
    `}
  `}
`

export default tertiaryCss
